import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { BuyerAuthGuard } from 'src/app/shared/services/buyer-auth.guard';
import { PublicSharedModule } from '../public-shared/public-shared.module';
import { BuyerRoutingModule } from './buyer-routing.module';
import { DirectPayComponent } from './components/direct-pay/direct-pay.component';
import { BuyerInfoModule } from './components/buyer-info/buyer-info.module';


@NgModule({
  declarations: [
    DirectPayComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PublicSharedModule,
    BuyerRoutingModule,
    BuyerInfoModule,
  ],
  providers: [
    BuyerAuthGuard
  ]
})
export class BuyerModule { }
